import { toast } from 'react-toastify'
import { setGlobalState, setStorageState, getGlobalState } from './store'
import { getPresistData } from './util'
import { io } from 'socket.io-client'
// import openSocket from 'socket.io-client'

// export const setRemoteCall = (callType, data, message,cb) => {
//   const socket = getGlobalState('socket')
//   socket.emit(callType, data)
//   if (message) toast(`Requesting from the server ${message}`)
// }

//get .loadingBar element
let loadingBar = document.querySelector('.loadingBar') || null

export const setRemoteCall = (callType, data, message, cb) => {
  const socket = getGlobalState('socket')
  if (!socket) {
    setTimeout(() => {
      setRemoteCall(callType, data, message, cb)
    }, 1000)
  } else {
    if (!loadingBar) {
      loadingBar = document.querySelector('.loadingBar') || null
    }
    if (loadingBar) loadingBar.style.opacity = '1'
    socket.emit(callType, data, (d) => {
      if (loadingBar) loadingBar.style.opacity = '0'
      cb && cb(d)
    })
    if (message) toast(`${message}`)
  }
}

export const socketListeners = (selfSocket) => {
  const socket = getGlobalState('socket')
  if (!socket) return null

  // Check token expiration periodically
  const checkTokenExpiration = () => {
    const loggedIn = getGlobalState('loggedIn')
    if (loggedIn && loggedIn.token) {
      try {
        // Decode JWT token (without verification)
        const base64Url = loggedIn.token.split('.')[1]
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const payload = JSON.parse(window.atob(base64))
        
        // Check if token is expired
        if (payload.exp && Date.now() >= payload.exp * 1000) {
          console.log('Token expired - redirecting to login')
          setGlobalState('loggedIn', null)
          setStorageState('loggedIn', null)
          socket.close()
          window.location.href = '/'
        }
      } catch (error) {
        console.error('Error checking token expiration:', error)
      }
    }
  }

  // Check token every minute
  const tokenCheckInterval = setInterval(checkTokenExpiration, 60000)
  
  // Store interval ID so it can be cleared later
  socket.tokenCheckInterval = tokenCheckInterval

  ///get initial data
  socket.emit('getInitData')
  // toast('Dados iniciais obtidos')

  socket.on('users', (received) => {
    setGlobalState('users', received || [])
    //let filter out available resources
    // if (received) {
    //   const availableUsers = received.filter(user => user.status === 1) || []
    //   setGlobalState('availableUsers', availableUsers)
    // }
    // toast(`Got ${received.length} users`)
  })
  socket.on('updateRelations', () => {
    setGlobalState('updateRelations', true)
    // toast(`Got ${received.length} users`)
  })
  socket.on('usersAvailable', (received) => {
    setGlobalState('availableUsers', received || [])
    // toast(`Got ${received.length} users`)
  })
  socket.on('userTypes', (received) => {
    setGlobalState('userTypes', received || [])
  })
  socket.on('userHistory', (received) => {
    setGlobalState('userHistory', received || [])
  })
  socket.on('projects', (received) => {
    console.log('Received projects', received)
    setGlobalState('projects', received || [])
    // toast(`Got ${received.length} projects`)
  })
  socket.on('projectHistory', (received) => {
    setGlobalState('projectHistory', received || [])
  })
  socket.on('projectTypes', (received) => {
    setGlobalState('projectTypes', received || [])
  })
  socket.on('resources', (received) => {
    setGlobalState('resources', received || [])
    // toast(`Got ${received.length} resources`)
    //let filter out available resources
    // if (received) {
    //   const availableResources =
    //     received.filter(resource => resource.status === 1) || []
    //   setGlobalState('availableResources', availableResources)
    // }
  })
  socket.on('resourcesAvailable', (received) => {
    setGlobalState('availableResources', received || [])
  })
  socket.on('resourceHistory', (received) => {
    setGlobalState('resourceHistory', received || [])
  })
  socket.on('resourceTypes', (received) => {
    setGlobalState('resourceTypes', received || [])
  })
  socket.on('relations', (received) => {
    setGlobalState('relations', received || [])
  })

  // Clean up interval on disconnect
  socket.on('disconnect', () => {
    if (socket.tokenCheckInterval) {
      clearInterval(socket.tokenCheckInterval)
    }
  })
}
export const checkAuthRoute = (redirectIfLoggedin) => {
  const loggedIn = getGlobalState('loggedIn')
  if (
    !loggedIn &&
    !getPresistData('tecnoremApp', 'loggedIn') &&
    window.location.pathname !== '/'
  ) {
    return (window.location = '/')
  } else if (
    redirectIfLoggedin &&
    loggedIn &&
    getPresistData('tecnoremApp', 'loggedIn')
  ) {
    return (window.location = '/dashboard')
  }
  return true
}

export const userLoggedIn = async () => {
  const loggedIn = getGlobalState('loggedIn')
  if (!loggedIn) return null

  const selfSocket = await io.connect('https://apipm.tecnorem.pt', {
    upgrade: true,
    query: `token=${loggedIn.token}`,
    extraHeaders: { Authorization: `Bearer ${loggedIn.token}` },
    // transports: ['websocket']
    // withCredentials: true,
    // upgrade: false,
    // query: `token=${loggedIn.token}`,
    // extraHeaders: { Authorization: `Bearer ${loggedIn.token}` },
    // transportOptions: {
    //   polling: {
    //     extraHeaders: {
    //       Authorization: `Bearer ${loggedIn.token}`
    //     }
    //   }
    // }
  })

  // const selfSocket = await openSocket('https://apipm.tecnorem.pt', {
  // const selfSocket = await openSocket('http://localhost:3002', {
  //   upgrade: false,
  //   query: `token=${loggedIn.token}`,
  //   extraHeaders: { Authorization: `Bearer ${loggedIn.token}` }
  //   // transports: ['websocket']
  // })

  //double cath when not working
  selfSocket.on('error', async (err) => {
    if (
      err.code === 'invalid_token' &&
      err.type === 'UnauthorizedError' &&
      err.message === 'jwt expired'
    ) {
      // Handle token expiration
      console.log('User token has expired')
      setGlobalState('loggedIn', null)
      setStorageState('loggedIn', null)
      await selfSocket.close()
      return (window.location = '/')
    }
  })

  selfSocket.on('unauthorized', async (error) => {
    console.log('Socket unauthorized event received:', error)
    if (
      error?.data?.type === 'UnauthorizedError' ||
      error?.data?.code === 'invalid_token'
    ) {
      // redirect user to login page
      console.log('User token has expired - redirecting to login')
      setGlobalState('loggedIn', null)
      setStorageState('loggedIn', null)
      selfSocket.close()
      window.location.href = '/'
    }
  })

  // Also handle connect_error which fires on connection failures
  selfSocket.on('connect_error', (error) => {
    console.log('Socket connection error:', error.message)
    if (error.message === 'Authentication error' || error.message.includes('jwt')) {
      console.log('Authentication failed - redirecting to login')
      setGlobalState('loggedIn', null)
      setStorageState('loggedIn', null)
      selfSocket.close()
      window.location.href = '/'
    }
  })

  setGlobalState('socket', selfSocket)
  socketListeners()
}
